// extracted by mini-css-extract-plugin
module.exports = {"main":"PreCaution_main__2HyoW"};